import {Component} from 'react';
import axios from "axios"
import Nav from "./Nav";
import Swal from "sweetalert2";
import myconfig from "../myconfig";
import $ from 'jquery';
import { Modal,Button } from 'react-bootstrap';

let source = axios.CancelToken.source();

class Status extends Component {
    constructor() {
        super();
        this.state = {
            menu: 'g-sidenav-show bg-gray-100',
            objs: [],
            objsload: false,
            choices:[],
            choice:"",
            statusshow:false,
            plateno:'',
            assign_id:"-1",
        }
    }

    async componentDidMount() {
        this.fetchdata();
    }
    fetchdata = async () => {
        this.setState({
            objs: [],
            objsload: false,
            choices:[],
            choice:"",
            statusshow:false,
            plateno:'',
            assign_id:"-1",
        })
        let baseurl = myconfig.getassignvehicles;
        let redirecttologin = myconfig.redirecttologin;
        let sid = new URLSearchParams(this.props.location.search).get("sid");
        let user = new URLSearchParams(this.props.location.search).get("user");
        await axios.post(baseurl, {
            "sid": sid,
            "user": user,
        }, {cancelToken: source.token}).then(res => {
            console.log(res.data)
            if (res.data.auth == false) {
                /*  window.localStorage.setItem("fas_sid", null);
                  window.localStorage.setItem("fas_username", null);
                  window.localStorage.setItem("fas_name", null);
                  var win = window.open(redirecttologin, "_self");*/
            } else if (res.data.success == false) {
                Swal.fire({
                    title: 'Error!',
                    text: res.data.message,
                    icon: 'error',
                    confirmButtonText: 'Okay'
                })
            } else {
                this.setState({
                    objs:res.data,
                    objsload:true,
                })
            }
        }).catch((e) => {
            console.log(e.message);
        });
    }
    inputmgt = (event) => {
        event.preventDefault();
        var name = event.target.name;
        var value = event.target.value;
        this.setState({
            [name]: value,
        })
    }
    componentWillUnmount() {
        try {
            if (source) {
                source.cancel("Landing Component got unmounted");
            }
        } catch (e) {

        }
    }
    menuhidden = (event) => {
        event.preventDefault();
        if (this.state.menu == "g-sidenav-show bg-gray-100")
            this.setState({
                menu: "g-sidenav-hidden bg-gray-100"
            })
        else
            this.setState({
                menu: "g-sidenav-show bg-gray-100"
            })
    }
    vehicletable = () => {
        let retdata=null;
        if(this.state.objsload) {
            let count=0;
            retdata = this.state.objs.vehicles.map(value => {
                count=count+1
                return (<tr>
                    <td>{count}</td>
                    <td>
                        <a className="btn btn-sm btn-outline-primary p-1 m-1" href="" onClick={(event => this.changestatus(event,value.id,value.plateno,value.status))}> Change Status </a>
                    </td>
                    <td>{value.plateno}</td>
                    <td>{value.capacity}</td>
                    <td>{value.type}</td>
                    <td>{value.tname}</td>
                    <td>{value.drivername}</td>
                    <td>{value.phoneno}</td>
                    <td>{value.tplateno}</td>
                    <td>{value.status}</td>
                </tr>)
            })
        }
        return (<>{retdata}</>)
    }
    changestatus = (event,assign_id,plateno,choice) => {
        event.preventDefault()
        let baseurl = myconfig.getstatuschoice;
        let redirecttologin = myconfig.redirecttologin;
        let sid = new URLSearchParams(this.props.location.search).get("sid");
        let user = new URLSearchParams(this.props.location.search).get("user");
        axios.post(baseurl, {
            "sid": sid,
            "user": user,
            "assign_id":assign_id,
        }, {cancelToken: source.token}).then(res => {
            console.log(res.data)
            if (res.data.auth == false) {
                /*  window.localStorage.setItem("fas_sid", null);
                  window.localStorage.setItem("fas_username", null);
                  window.localStorage.setItem("fas_name", null);
                  var win = window.open(redirecttologin, "_self");*/
            } else if (res.data.success == false) {
                Swal.fire({
                    title: 'Error!',
                    text: res.data.message,
                    icon: 'error',
                    confirmButtonText: 'Okay'
                })
            } else {
                this.setState({
                    statusshow:true,
                    plateno:plateno,
                    assign_id:assign_id,
                    choice:choice,
                    choices:res.data.choices,
                })
            }
        }).catch((e) => {
            console.log(e.message);
        });

    }
    hidestatus = () => {
        this.setState({
            statusshow: false,
        })
    }
    modalstatus=()=> {
        let options=this.state.choices.map(value => {
            return <option value={value.status}>{value.status}</option>
        })
        return (<Modal
                size="md"
                aria-labelledby="contained-modal-title-vcenter"
                centered
                show={this.state.statusshow}
                onHide={this.hidestatus}>
                <Modal.Header><h4>Vehicle Status</h4>
                    <small>(change)</small></Modal.Header>
                <Modal.Body>
                    <div className="row">
                        <div className="col-12">
                            <label>Plate No</label>
                            <input disabled className="form-control" type="text" name="plateno" onChange={this.inputmgt} value={this.state.plateno}/>
                        </div>
                        <div className="col-12">
                            <label>Status</label>
                            <select className="form-control" name="choice" onChange={this.inputmgt} value={this.state.choice}>
                                <option value="-1">-- Select Status --</option>
                                {options}
                            </select>
                        </div>
                        <div className="col-12">
                            <button onClick={this.btnchange} className="btn mt-3 btn-block btn-outline-primary">Change Status</button>
                        </div>
                    </div>
                </Modal.Body>
            </Modal>
        )
    }
    btnchange = (event) => {
        event.preventDefault();
        let baseurl = myconfig.updatestatus;
        let redirecttologin = myconfig.redirecttologin;
        let sid = new URLSearchParams(this.props.location.search).get("sid");
        let user = new URLSearchParams(this.props.location.search).get("user");
        axios.post(baseurl, {
            "sid": sid,
            "user": user,
            "assign_id":this.state.assign_id,
            "status":this.state.choice,
        }, {cancelToken: source.token}).then(res => {
            console.log(res.data)
            if (res.data.auth == false) {
                /*  window.localStorage.setItem("fas_sid", null);
                  window.localStorage.setItem("fas_username", null);
                  window.localStorage.setItem("fas_name", null);
                  var win = window.open(redirecttologin, "_self");*/
            } else if (res.data.success == false) {
                Swal.fire({
                    title: 'Error!',
                    text: res.data.msg,
                    icon: 'error',
                    confirmButtonText: 'Okay'
                })
            }
            else {
                Swal.fire({
                    title: 'Success',
                    text: res.data.msg,
                    icon: 'success',
                    confirmButtonText: 'Okay',

                }).then(value => {
                    let reurl = window.location.origin + myconfig.order
                    this.successumit()
                })
            }
        }).catch((e) => {
            console.log(e.message);
        });
    }
    successumit=()=> {
        this.fetchdata();
    }
    render() {
        return (

            <>
                <>
                    <Nav type="admin_status"/>
                    <div className="content-wrapper">
                        <div className="content-header">
                            <div className="container-fluid">
                                <div className="row mb-2">
                                    <div className="col-sm-6">
                                        <h1 className="m-0">Status Managment</h1>
                                    </div>
                                    <div className="col-sm-6">
                                        <ol className="breadcrumb float-sm-right">
                                            <li className="breadcrumb-item"><a href="#">Status</a></li>
                                            <li className="breadcrumb-item active"></li>
                                        </ol>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <section className="content">
                            <div className="container-fluid">
                                <div className="row">
                                    <div className="col-12">
                                        <div className="card">
                                            <div className="card-header">
                                                <h3 className="card-title">Status Report</h3>
                                                <div className="card-tools">
                                                </div>
                                            </div>
                                            {/* /.card-header */}
                                            <div className="card-body table-responsive p-0" style={{height: '500px'}}>
                                                <table className="table table-head-fixed text-nowrap">
                                                    <thead>
                                                    <tr>
                                                        <th>#</th>
                                                        <th>Action</th>
                                                        <th>Truck</th>
                                                        <th>Capcity</th>
                                                        <th>Type</th>
                                                        <th>Transporter</th>
                                                        <th>Status</th>
                                                        <th>Driver Name</th>
                                                        <th>Phone #</th>
                                                        <th>Trailer #</th>

                                                    </tr>
                                                    </thead>
                                                    <tbody>
                                                    {this.vehicletable()}
                                                    </tbody>
                                                </table>
                                            </div>
                                            {/* /.card-body */}
                                        </div>
                                        {/* /.card */}
                                    </div>
                                </div>
                            </div>
                        </section>
                    </div>
                </>
                {this.modalstatus()}
            </>
        )
    }
}

export default Status;
